import { t } from 'i18next';
import { FloorplanRevision } from '@thive/fddm-types';

import { useObjectValidation } from '@/modules/common/hooks/useObjectValidation';
import { useSnackbarStore } from '@/modules/snackbar/store/useSnackbarStore';

const requiredKeys: (keyof FloorplanRevision)[] = ['metaData', 'setup', 'design'];

export const useFloorplanObjectValidation = () => {
  const { showSnackbar } = useSnackbarStore();
  const { validateKeys } = useObjectValidation();

  const isValidFloorplan = (floorplan: object): floorplan is FloorplanRevision => {
    if (!validateKeys(floorplan, requiredKeys, false)) {
      showSnackbar(t('errors:invalid_data_format'));
      return false;
    }

    return true;
  };

  return { isValidFloorplan };
};
